<template>
  <main class="notfound-main">
    <!-- Background with coffee bean on the right (desktop) -->
    <div class="background-container background-desktop">
      <img 
        src="@/assets/img/KV_Fond_Dotation.jpg" 
        alt="Background" 
        class="background-image"
      />
    </div>
    
    <!-- Background with coffee bean centered (mobile) -->
    <div class="bean-section-mobile"></div>

    <!-- Main container - Two columns layout -->
    <div class="container">
      <div class="content-wrapper">
        <!-- Left column: Text content centered -->
        <div class="left-column">
          <div class="text-content">
            <h1 class="title">OUPS...</h1>
            
            <p class="message">
              La page est introuvable.
            </p>
          </div>
        </div>

        <!-- Right column: Space for coffee bean background -->
        <div class="right-column"></div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "NotFoundView",
};
</script>

<style scoped>
.notfound-main {
  background-color: #000;
  color: white;
  position: relative;
  min-height: calc(100vh - 150px);
  display: flex;
  flex-direction: column;
}

/* Container */
.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 60px;
  position: relative;
  z-index: 10;
  width: 100%;
  flex: 1;
}

/* Background - Coffee bean on the right */
.background-container {
  position: absolute;
  top: 0;
  left: 0%;
  bottom: 5%;
  width: 100%;
  pointer-events: none;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  transition: all 0.3s ease;
}

.background-desktop {
  display: flex;
}

.bean-section-mobile {
  display: none;
}

.background-image {
  width: auto;
  height: 110%;
  max-height: none;
  object-fit: cover;
  object-position: center;
  transition: all 0.3s ease;
}

/* Content wrapper */
.content-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  min-height: calc(100vh - 150px);
  align-items: center;
}

/* Left Column - Text centered */
.left-column {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 60px 0;
}

.text-content {
  text-align: center;
}

.title {
  font-family: var(--font-primary);
  font-size: 48px;
  font-weight: 900;
  line-height: 1.2;
  margin: 0 0 30px 0;
  color: white;
  text-transform: uppercase;
}

.message {
  font-family: var(--font-primary);
  font-weight: 500;
  font-size: 34px;
  color: white;
  line-height: 1.1;
  margin: 0;
}

/* Right Column - Empty for background */
.right-column {
  /* Space for coffee bean background */
}

/* Tablet breakpoint */
@media (max-width: 1024px) {
  .content-wrapper {
    grid-template-columns: 1.2fr 0.8fr;
  }

  .background-container {
    width: 50%;
  }
}

/* Mobile/Tablet transition */
@media (max-width: 768px) {
  .notfound-main {
    min-height: auto;
  }

  .container {
    padding: 0 20px;
    order: 1;
  }

  .content-wrapper {
    grid-template-columns: 1fr;
    min-height: auto !important;
    height: auto;
  }

  .left-column {
    min-height: auto;
    height: auto;
    padding: 40px 0 0 0;
  }

  .background-desktop {
    display: none;
  }

  .bean-section-mobile {
    display: block;
    width: 100%;
    height: 350px;
    order: 2;
    background-image: url('@/assets/img/KV_Fond.jpg');
    background-size: 120% auto;
    background-position: center 70%;
    background-repeat: no-repeat;
    background-color: #000;
  }

  .right-column {
    display: none;
  }

  .title {
    font-size: clamp(32px, 8vw, 48px);
    margin-bottom: 20px;
  }

  .message {
    font-size: clamp(18px, 5vw, 24px);
  }
}

/* Small mobile */
@media (max-width: 480px) {
  .bean-section-mobile {
    height: 300px;
    background-size: 140% auto;
  }
}
</style>
